// Журнал офиса: кто и что изменил — фразами, не диффами.
import { useState } from 'react';
import { downloadCsv } from './csv';
import { useQuery } from '@tanstack/react-query';
import { AuditList } from '@dastarhan/contracts';

const API = '/api/v1';

export function AuditScreen({ token, isOwner }: { token: string; isOwner: boolean }) {
  const [flt, setFlt] = useState('');
  const [from, setFrom] = useState('');
  const [to, setTo] = useState('');
  const audit = useQuery({
    queryKey: ['audit', from, to],
    enabled: isOwner,
    refetchInterval: 30_000,
    queryFn: async () => AuditList.parse(
      await (await fetch(`${API}/audit${from && to ? `?from=${from}&to=${to}` : ''}`, { headers: { Authorization: `Bearer ${token}` } })).json(),
    ),
  });

  if (!isOwner) return <p className="empty">Журнал действий видит только владелец.</p>;
  if (audit.isPending) return <p className="empty">Открываем журнал…</p>;
  if (audit.isError || !audit.data) return <p className="empty">Не удалось загрузить. Обновите страницу.</p>;
  if (audit.data.rows.length === 0) {
    return <p className="empty">Пока пусто. Здесь появятся изменения цен, прав, ставок и настроек.</p>;
  }

  return (
    <div className="audit">
      <button className="btn small" style={{ alignSelf: 'flex-start' }}
        onClick={() => downloadCsv('аудит.csv', [
          ['Когда', 'Кто', 'Действие'],
          ...audit.data!.rows.filter((r) => !flt.trim() || r.message.toLowerCase().includes(flt.trim().toLowerCase())).map((r) => [new Date(r.at).toLocaleString('ru-RU'), r.userName, r.message]),
        ])}>CSV</button>
      <input className="field" style={{ margin: '8px 0', width: 280 }} placeholder="Фильтр: цену, архив, вернул…"
        value={flt} onChange={(e) => setFlt(e.target.value)} />
      <button className="btn small" onClick={() => setFlt('цену')}>Цены</button>
      <button className="btn small" onClick={() => setFlt('стоп')}>Стопы</button>
      <span className="hint-inline" style={{ marginLeft: 12 }}>Период:</span>
      <input type="date" value={from} onChange={(e) => setFrom(e.target.value)} />
      <span className="hint-inline">–</span>
      <input type="date" value={to} onChange={(e) => setTo(e.target.value)} />
      {(from || to) && <button className="btn small" onClick={() => { setFrom(''); setTo(''); }}>×</button>}
      <button className="btn small" onClick={() => setFlt('')}>Все</button>
      {audit.data.rows.filter((r) => !flt.trim() || r.message.toLowerCase().includes(flt.trim().toLowerCase())).map((r, i) => (
        <div key={i} className="audit-row">
          <span className="hint-inline">
            {new Date(r.at).toLocaleString('ru-RU', {
              day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit',
            })}
          </span>
          <span><b>{r.userName}</b> {r.message}</span>
        </div>
      ))}
    </div>
  );
}
